import React, { memo, useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import classNames from 'classnames';
import styles from './Welcome.module.less';
import UserPortrait from './UserPortrait';
import RecommdendList from './RecommendList';
import { setWelcomeInit } from '../../actions/welcome';
import Loading from '../../components/Loading/Loading';
import { logging } from '../../actions/log';
import { welcomePopTime } from '../../constants/storageKeys';
import dayjs from 'dayjs';

const selectLocalSoftsInit = createSelector(
  state => state.native,
  native => native.installedSoftInit,
);
const selectWelcomeData = createSelector(
  state => state.welcome,
  welcome => welcome.welcomeData,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
export default memo(() => {
  const [visible, setVisible] = useState(true);
  const [isNewUser, setIsNewUser] = useState(false);
  const [showSofts, setShowSofts] = useState(false);
  const [firstGuide, setFirstGuide] = useState(false);
  const installedSoftInit = useSelector(selectLocalSoftsInit);
  const dispatch = useDispatch();
  const welcomeData = useSelector(selectWelcomeData);
  const logInfoData = useSelector(selectLogInfo);
  const [sf, setSf] = useState(false);
  const [initTime, setInitTime] = useState();

  useEffect(() => {
    setInitTime(+new Date());
  }, []);
  useEffect(() => {
    const nowTime = dayjs(+new Date()).format('YYYYMMDD');
    localStorage.setItem(welcomePopTime, nowTime);
  }, []);
  // 判断是否是新年特变版
  useEffect(() => {
    if (!firstGuide) {
      setSf(false);
    } else {
      setSf(false);
    }
  }, [firstGuide]);

  /**
   * 统计页面浏览时长
   */
  useEffect(() => {
    if ((!isNewUser && !showSofts) || !visible) {
      const leaveTime = +new Date();
      dispatch(
        logging({
          category: 'I',
          action: 'View_Time',
          label: '',
          param2: {
            source: `Welcome`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            initTime,
            leaveTime,
            time: leaveTime - initTime,
          },
        }),
      );
    }
  }, [isNewUser, showSofts, visible]);

  useEffect(() => {
    if (localStorage.getItem('WELCOME_USER') === 'NO') {
      setIsNewUser(false);
    } else {
      setIsNewUser(true);
    }
    return () => {
      dispatch(
        setWelcomeInit({
          init: true,
        }),
      );
    };
  }, []);
  useEffect(() => {
    if (isNewUser && installedSoftInit && installedSoftInit.length > 0) {
      setFirstGuide(true);
    }
  }, [installedSoftInit, isNewUser]);

  const handleClose = useCallback(() => {
    // 新手引导打桩
    if (isNewUser) {
      dispatch(
        logging({
          category: 'C',
          action: 'Guide_Close',
          label: '',
          param2: {
            source: 'Guide',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
    } else {
      dispatch(
        logging({
          category: 'C',
          action: 'W_Close',
          label: '',
          param2: {
            source: 'Welcome',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
    }
    setVisible(false);
  }, [visible, isNewUser]);

  useEffect(() => {
    const userType = JSON.parse(localStorage.getItem('WELCOME_USER_TYPE')) || ['1'];
    if (
      !welcomeData ||
      !userType ||
      userType.length < 1 ||
      !installedSoftInit ||
      installedSoftInit.length < 1
    ) {
      return;
    }
    let data = userType
      .map(id => {
        return (
          welcomeData.guideResultMap &&
          welcomeData.guideResultMap[id] && {
            ...welcomeData.guideResultMap[id].rankInfo,
            imgUrl: welcomeData.guideResultMap[id].imgUrl,
          }
        );
      })
      .filter(item => item); // 根据用户选择的类型排序
    // 过滤已安装的软件;
    data = data.map(item => {
      return {
        ...item,
        apps: item.apps.filter(app => {
          return !installedSoftInit.find(
            soft => app.softID === soft.SoftID || app.softID === soft.softID,
          );
        }),
      };
    });
    // 根据用户画像个数确定最后的翻页展示数据
    let bannerData = [];
    if (userType.length < 2) {
      const len = data[0] && data[0].apps.length;
      // eslint-disable-next-line radix
      let page = len % 8 === 0 ? parseInt(len / 8) : parseInt(len / 8) + 1;
      while (page > 0) {
        bannerData.unshift({
          ...data[0],
          apps: data[0].apps.slice(
            (page - 1) * 8,
            (page - 1) * 8 + 8 >= len ? len : (page - 1) * 8 + 8,
          ),
        });
        page -= 1;
      }
    } else {
      bannerData = data.map(item => ({ ...item, apps: item.apps.slice(0, 8) }));
    }
    bannerData = bannerData.filter(item => item.apps.length >= 4);
    if (Object.keys(welcomeData.guideResultMap).length > 0 && bannerData.length < 1) {
      setShowSofts(false);
    } else {
      setShowSofts(true);
    }
  }, [welcomeData, installedSoftInit]);

  if (
    !visible ||
    (!isNewUser && !showSofts) ||
    (welcomeData && !welcomeData.guideResultMap) ||
    (welcomeData &&
      Object.keys(welcomeData.guideResultMap).length < 1 &&
      localStorage.getItem('WELCOME_USER') === 'NO') ||
    !installedSoftInit ||
    installedSoftInit.length < 1
  ) {
    return null;
  }

  return (
    <div className={styles.mask}>
      <div className={classNames(styles.popUp, { [styles.popUp_festival]: sf })}>
        <div className={sf ? styles.popUp_close_sf : styles.popUp_close}>
          {!isNewUser && (
            <span className="icon" onClick={handleClose}>
              <i className="iconfont icon-close" />
            </span>
          )}
        </div>
        {(isNewUser || showSofts) && !welcomeData && <Loading />}
        {isNewUser && (
          <UserPortrait
            handleIsNewUser={type => {
              setIsNewUser(type);
              setShowSofts(!type);
            }}
          />
        )}

        {!isNewUser && showSofts && (
          <RecommdendList
            firstGuide={firstGuide}
            handleSoftsVisble={type => {
              setShowSofts(type);
            }}
          />
        )}
      </div>
    </div>
  );
});
